import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteProductPhoto, fetchProductPhotos, uploadSingleProductPhoto } from "./productPhotosApi";

export const fetchProductPhotosThunk = createAsyncThunk(
    "productPhotos/fetchAll",
    async ({ sellerId, filters, pagination }, { rejectWithValue, signal }) => {
        try {
            const data = await fetchProductPhotos({ sellerId, filters, pagination }, signal);
            return data;
        } catch (error) {
            console.error("Error deleting product photo:", error);
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const deleteProductPhotoThunk = createAsyncThunk(
    "productPhotos/delete",
    async (photoUrl, { rejectWithValue, signal }) => {
        try {
            await deleteProductPhoto(photoUrl, signal);
            return photoUrl;
        } catch (error) {
            console.error("Error deleting product photo:", error);
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
)